import { LuArrowLeft } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';

interface NavigationHeaderProps {
    title: React.ReactNode;
    onBack?: (e?: any) => void;
}

export const NavigationHeader = (props: NavigationHeaderProps) => {
    const navigate = useNavigate();
    return (
        <div className='bg-background-surface border-border-default flex w-full items-center justify-between gap-4 self-stretch border-b px-5 py-4'>
            <div
                onClick={(e) => {
                    if (props.onBack) props.onBack(e);
                    else {
                        e.stopPropagation();
                        navigate(-1);
                    }
                }}
                className='size-10 content-center justify-items-center'
                data-testid='navigation-header-back-button'>
                <LuArrowLeft className='size-6' />
            </div>
            <div className='text-center text-xl font-semibold'>{props.title}</div>
            <div className='text-brand-primary size-10 content-center justify-items-center'>{/* <LuCircleHelp className='size-6' /> */}</div>
        </div>
    );
};
